import {
  GET_BUSINESS_COLOR_PALETTES_SUCCESS,
  GET_PUBLIC_COLOR_PALETTES_SUCCESS,
  GET_COLOR_PALETTE_SUCCESS,
  POST_COLOR_PALETTE_SUCCESS,
  RESET_POSTED_COLOR_PALETTE,
} from "Containers/ColorPalettes/types"

// Store purement legacy (REST). Les palettes V2 (SMISetting) sont lues via Shared/hooks/useBusinessPalettes.
const initialState = {
  publicColorPalettes: [],
  businessColorPalettes: [],
  selectedColorPalette: {},
  postedColorPalette: {},
}

function colorPalettesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_BUSINESS_COLOR_PALETTES_SUCCESS:
      return {
        ...state,
        businessColorPalettes: payload.body,
      }
    case GET_PUBLIC_COLOR_PALETTES_SUCCESS:
      return {
        ...state,
        publicColorPalettes: payload.body,
      }
    case GET_COLOR_PALETTE_SUCCESS:
      return {
        ...state,
        selectedColorPalette: payload.body,
      }
    case POST_COLOR_PALETTE_SUCCESS:
      return {
        ...state,
        postedColorPalette: payload.body,
      }
    case RESET_POSTED_COLOR_PALETTE:
      return {
        ...state,
        postedColorPalette: {},
      }
    default:
      return state
  }
}

export default colorPalettesReducer
